import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class LeadService {

    static getLead(item) {

        let api = `${API_BASE_URL}${API_PATHS.getlead}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
        if (item?.search) params.append("search", item.search);


        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addLead(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addlead}`;
        return axiosInstance
            .post(api, data)

    }

    static leadSync(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.leadsync}`;
        return axiosInstance
            .post(api, data)

    }

    static getLeadActivity(item) {

        let api = `${API_BASE_URL}${API_PATHS.getleadactivity}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.leadId) params.append("leadId", item.leadId);

        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api, item);
    }

    static addLeadActivity(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addleadactivity}`;
        return axiosInstance
            .post(api, data)

    }

    static editLead(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editlead}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteLead(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletelead}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default LeadService;
